import { APIClient } from "helpers/api_helper";

const api = new APIClient();

export async function getTransactionsByUserId() {
  try {
    const response = await api.get(`merchant/transactions`);
    return response?.data;
  } catch (e) {
    console.error(e); // Log the error for debugging
    throw new Error("Transactions could not be loaded.");
  }
}
